// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!./assets/Fonts/Poppins/stylesheet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logOutModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body-has-title .ant-modal-confirm-paragraph .ant-modal-confirm-title {
  color: #040f0f;
  font-weight: 700;
}
.logOutModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body-has-title .ant-modal-confirm-paragraph .ant-modal-confirm-content {
  font-size: 14px;
  color: #a3a3a3;
}
.logOutModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-btns {
  margin-top: 20px !important;
}
.logOutModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-btns button:nth-child(2) {
  border: none !important;
  background-color: transparent !important;
  color: #a3a3a3 !important;
}
.verifyEmailModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body-has-title .ant-modal-confirm-paragraph .ant-modal-confirm-title {
  color: #040f0f;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
}
.verifyEmailModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body-has-title .ant-modal-confirm-paragraph .ant-modal-confirm-content {
  color: #a3a3a3;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.verifyEmailModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-btns button:nth-child(2) {
  border: none !important;
  background-color: transparent !important;
  color: #a3a3a3 !important;
}
.verifyEmailModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-btns p {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-weight: 500 !important;
  font-size: 14px;
  margin-top: 10px;
}
.verifyEmailModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-btns p .anchor-btn {
  background-color: transparent !important;
  border: none;
  color: #012969 !important;
  padding: 0px !important;
}
.verifyEmailModal .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-btns p .anchor-btn span {
  font-weight: 600 !important;
  font-size: 14px;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-paragraph {
  row-gap: 20px;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-paragraph .ant-modal-confirm-title {
  color: #040f0f;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-align: left;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .customPhoneNumberWrapper {
  height: 100%;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .customPhoneNumberWrapper .PhoneInputInput {
  color: #000000e0;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .anticon {
  color: #a3a3a3;
  padding-right: 4px;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item button {
  border-radius: 12px !important;
  padding: 10px 35px !important;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .ant-form-item-control .ant-form-item-explain-error {
  color: #d38104;
  font-weight: 300 !important;
  padding-left: 4px;
  padding-top: 10px;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .ant-form-item-control .ant-input-status-error svg {
  color: #012969;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .ant-form-item-control .ant-input-status-error img {
  filter: brightness(0) saturate(100%) invert(14%) sepia(84%) saturate(2948%) hue-rotate(339deg) brightness(110%) contrast(98%);
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .custom-form-item .ant-form-item-control .ant-input-password input {
  padding: 0px !important;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .checkboxWrapper {
  text-align: left;
}
.formModal .ant-modal-confirm .ant-modal-body .ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content .custom-form-container .checkboxWrapper span {
  color: #a3a3a3;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.iconButton {
  background-color: transparent !important;
  display: inline-block;
  padding: 0 !important;
  border: none !important;
}
.noConnectionLoader {
  height: 100vh;
  width: 100vw;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 11;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
h5 {
  font-size: 13px;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0em;
  margin: 0;
  padding-bottom: 8px;
}
p {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0em;
  margin: 0;
  padding-bottom: 8px;
}
ul {
  padding-left: 0;
}
ul li {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0em;
  margin: 0;
  padding-bottom: 5px;
  list-style: none;
}
.ant-form-item-explain-error {
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins", sans-serif;
  line-height: 1;
  text-align: left;
  padding-top: 4px;
  padding-left: 12px;
  letter-spacing: 0em;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.aside {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.w-100 {
  width: 100%;
}
.w-50 {
  width: 50%;
}
.w-0 {
  width: 0%;
}
.my-10 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.my-15 {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}
.my-20 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.my-25 {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.my-30 {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}
/* Margin Utilities */
.m-0 {
  margin: 0;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 1rem;
}
.m-4 {
  margin: 1.5rem;
}
.m-5 {
  margin: 3rem;
}
.m-auto {
  margin: auto;
}
/* Margin Top Utilities */
.mt-0 {
  margin-top: 0 !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mt-3 {
  margin-top: 1rem !important;
}
.mt-4 {
  margin-top: 1.5rem !important;
}
.mt-5 {
  margin-top: 3rem !important;
}
/* Margin Bottom Utilities */
.mb-0 {
  margin-bottom: 0 !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mb-3 {
  margin-bottom: 1rem !important;
}
.mb-4 {
  margin-bottom: 1.5rem !important;
}
.mb-5 {
  margin-bottom: 3rem !important;
}
/* Margin Left Utilities */
.ml-0 {
  margin-left: 0;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 1rem;
}
.ml-4 {
  margin-left: 1.5rem;
}
.ml-5 {
  margin-left: 3rem;
}
/* Margin Right Utilities */
.mr-0 {
  margin-right: 0;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 1rem;
}
.mr-4 {
  margin-right: 1.5rem;
}
.mr-5 {
  margin-right: 3rem;
}
/* Vertical Margin Utilities */
.my-0 {
  margin-top: 0;
  margin-bottom: 0;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
/* Horizontal Margin Utilities */
.mx-0 {
  margin-left: 0;
  margin-right: 0;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-4 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-5 {
  margin-left: 3rem;
  margin-right: 3rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
/* Padding Utilities */
.p-0 {
  padding: 0 !important;
}
.p-1 {
  padding: 0.25rem !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.p-3 {
  padding: 1rem !important;
}
.p-4 {
  padding: 1.5rem !important;
}
.p-5 {
  padding: 3rem !important;
}
/* Padding Top Utilities */
.pt-0 {
  padding-top: 0 !important;
}
.pt-1 {
  padding-top: 0.25rem !important;
}
.pt-2 {
  padding-top: 0.5rem !important;
}
.pt-3 {
  padding-top: 1rem !important;
}
.pt-4 {
  padding-top: 1.5rem !important;
}
.pt-5 {
  padding-top: 3rem !important;
}
/* Padding Bottom Utilities */
.pb-0 {
  padding-bottom: 0 !important;
}
.pb-1 {
  padding-bottom: 0.25rem !important;
}
.pb-2 {
  padding-bottom: 0.5rem !important;
}
.pb-3 {
  padding-bottom: 1rem !important;
}
.pb-4 {
  padding-bottom: 1.5rem !important;
}
.pb-5 {
  padding-bottom: 3rem !important;
}
.space-between {
  justify-content: space-between;
}
.bordered {
  border: 1px solid #dde1e6;
}
#addEditContractForm .anticon-delete,
#addEditPlanForm .anticon-delete {
  height: 45px;
}
.edit span.kl-custom-heading,
.dashboardMain span.kl-custom-heading {
  padding: 0 0 20px 0;
  display: inline-block;
}
.edit table .ant-table-thead tr th,
.dashboardMain table .ant-table-thead tr th,
.edit table .ant-table-thead tr > td,
.dashboardMain table .ant-table-thead tr > td {
  background-color: #e9e9e9;
  padding: 14px 10px;
  color: #000000;
  font-weight: 500;
  border: unset !important;
  font-size: 15px;
}
.edit table .ant-table-thead tr th span,
.dashboardMain table .ant-table-thead tr th span,
.edit table .ant-table-thead tr > td span,
.dashboardMain table .ant-table-thead tr > td span {
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.edit table .ant-table-thead tr:first-child th:first-child,
.dashboardMain table .ant-table-thead tr:first-child th:first-child {
  padding-left: 20px !important;
}
.edit table .ant-table-thead tr:first-child th:last-child,
.dashboardMain table .ant-table-thead tr:first-child th:last-child {
  padding-right: 20px !important;
}
.edit table tbody > tr > td,
.dashboardMain table tbody > tr > td {
  padding: 14px 8px !important;
  border-right: none;
  border-bottom: none !important;
  color: #000000;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0em;
}
.edit table tbody > tr > td:first-child,
.dashboardMain table tbody > tr > td:first-child {
  padding-left: 25px !important;
}
.edit table tbody > tr > td:last-child,
.dashboardMain table tbody > tr > td:last-child {
  padding-right: 0 !important;
}
.edit table .anticon.anticon-delete,
.dashboardMain table .anticon.anticon-delete {
  color: #ff4d4f;
  font-size: 18px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 0px;
}
::-webkit-scrollbar-thumb {
  background: #012969;
}
::-webkit-scrollbar-thumb:hover {
  background: #3a3a3c;
}
.ant-picker-cell-hover .ant-picker-cell-inner,
.ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #012969 !important;
  color: #ffffff;
}
html,
div,
h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
span,
table,
th,
td,
input,
textarea,
select {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}
.ant-modal-confirm .ant-modal-body {
  padding: 35px !important;
}
.ant-modal-confirm .ant-modal-content {
  background-color: #ffffff;
  min-height: auto;
  border-radius: 8px;
  padding: 0;
}
.ant-modal-confirm .ant-modal-content .ant-modal-confirm-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ant-modal-confirm .ant-modal-content .icon-wrapper svg {
  color: #012969;
  font-size: 50px;
}
.ant-modal-confirm .ant-modal-content .ant-modal-confirm-title {
  font-size: 23px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #012969;
  text-align: center;
  line-height: 1;
  padding-top: 20px;
  padding-bottom: 5px;
}
.ant-modal-confirm .ant-modal-content .ant-modal-confirm-content {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0em;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  color: #000000;
}
.ant-modal-confirm .ant-modal-confirm-btns {
  border: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 40px !important;
}
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  color: #ffffff !important;
  background-color: #012969 !important;
  font-size: 16px !important;
  font-family: "Roboto";
  line-height: unset !important;
  letter-spacing: 0em;
  padding: 12px 40px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  height: unset !important;
  display: block;
  width: 100%;
}
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn:hover {
  opacity: 0.8;
  color: #012969 !important;
  background-color: #ffffff !important;
  border-color: #012969 !important;
}
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover {
  opacity: 0.8;
}
.ant-modal-confirm .ant-modal-close {
  color: #ad0c17;
  transition: all 0.4s ease-in-out;
  background: unset !important;
}
.ant-modal-confirm .ant-modal-close:hover {
  transform: rotate(90deg);
}
.ant-modal-confirm .ant-modal-close:hover {
  transform: translateX(20deg);
}
.delete-modal .icon-wrapper {
  border-color: transparent !important;
}
.delete-modal .icon-wrapper svg {
  color: #ad0c17 !important;
}
.form-modal .custom-row .ant-row {
  flex-direction: column;
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.form-modal .ant-form-item-label > label {
  color: #222;
  width: 100%;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: left;
  line-height: 1;
  height: unset;
  margin-bottom: 10px;
}
.form-modal .update-btn-row {
  text-align: right;
}
.form-modal .update-btn-row button {
  margin-right: 10px;
}
.form-modal .kl-custom-input-container input,
.form-modal .kl-custom-textarea-container textarea {
  padding: 12px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  color: #000;
}
.form-modal .kl-custom-textarea-container textarea {
  height: 260px !important;
  overflow: auto;
  resize: none;
}
.form-modal .kl-custom-input-container input::placeholder {
  font-size: 16px;
  color: #00000080;
  opacity: 1;
}
.form-modal .ant-btn {
  border: 1px solid #012969 !important;
  height: unset !important;
  padding: 8px 22px !important;
  font-size: 14px !important;
  border-radius: 4px !important;
  color: #012969 !important;
  border-color: #012969 !important;
  background: #fff !important;
  font-weight: 400 !important;
}
.form-modal .imagePreview {
  padding: 60px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 1px solid #ced4da;
  border-radius: 4px;
}
.form-modal p {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  color: #222;
  margin-bottom: 0;
  line-height: 1;
}
.form-modal .aside {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.form-modal .aside .forgot-pass button {
  all: unset;
  font-size: 14px !important;
  font-weight: 500 !important;
  letter-spacing: 0px;
  text-align: right;
  color: #636363 !important;
  transition: all 0.4s ease-in-out;
  background: unset !important;
  border: none !important;
  padding: 0 !important;
  line-height: 1 !important;
  text-shadow: unset !important;
  box-shadow: unset !important;
  border-radius: unset !important;
  cursor: pointer !important;
  border-bottom: 1px solid !important;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .filtersGrid {
    display: flex;
    flex-direction: column;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .edit table .ant-table-thead tr th,
  .dashboardMain table .ant-table-thead tr th,
  .edit table .ant-table-thead tr > td,
  .dashboardMain table .ant-table-thead tr > td {
    padding: 10px 8px;
    line-height: 1.2;
    font-size: 13px;
  }
  .edit table .ant-table-thead tr th span,
  .dashboardMain table .ant-table-thead tr th span,
  .edit table .ant-table-thead tr > td span,
  .dashboardMain table .ant-table-thead tr > td span {
    font-size: 13px;
  }
  .edit table tbody > tr > td,
  .dashboardMain table tbody > tr > td {
    padding: 10px 8px !important;
    line-height: 1.2;
  }
  .filtersGrid {
    display: flex;
    flex-direction: column;
  }
  .ant-modal-confirm .ant-modal-content .icon-wrapper svg {
    font-size: 42px;
  }
  .ant-modal-confirm .ant-modal-content .ant-modal-confirm-title {
    font-size: 22px;
  }
  .ant-modal-confirm .ant-modal-content .ant-modal-confirm-content {
    font-size: 16px;
  }
  .ant-modal-confirm .ant-modal-confirm-btns {
    margin-top: 20px !important;
  }
  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
    font-size: 14px !important;
    padding: 10px 20px !important;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .edit table .ant-table-thead tr th,
  .dashboardMain table .ant-table-thead tr th,
  .edit table .ant-table-thead tr > td,
  .dashboardMain table .ant-table-thead tr > td {
    padding: 10px 8px;
    line-height: 1.2;
    font-size: 13px;
  }
  .edit table .ant-table-thead tr th span,
  .dashboardMain table .ant-table-thead tr th span,
  .edit table .ant-table-thead tr > td span,
  .dashboardMain table .ant-table-thead tr > td span {
    font-size: 13px;
  }
  .edit table tbody > tr > td,
  .dashboardMain table tbody > tr > td {
    padding: 10px 8px !important;
  }
  .filtersGrid {
    display: flex;
    flex-direction: column;
  }
  .ant-modal-confirm .ant-modal-content .icon-wrapper svg {
    font-size: 42px;
  }
  .ant-modal-confirm .ant-modal-content .ant-modal-confirm-title {
    font-size: 22px;
  }
  .ant-modal-confirm .ant-modal-content .ant-modal-confirm-content {
    font-size: 16px;
  }
  .ant-modal-confirm .ant-modal-confirm-btns {
    margin-top: 20px !important;
  }
  .ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
    font-size: 14px !important;
    padding: 10px 20px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.less"],"names":[],"mappings":"AAQA;EAQc,cAAA;EACA,gBAAA;AAbd;AAIA;EAYc,eAAA;EACA,cAAA;AAbd;AAAA;EAkBU,2BAAA;AAfV;AAiBY;EACE,uBAAA;EACA,wCAAA;EACA,yBAAA;AAfd;AA2BA;EAQgB,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAhChB;AAmBA;EAgBgB,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAhChB;AAsCc;EACE,uBAAA;EACA,wCAAA;EACA,yBAAA;AApChB;AAMA;EAkCc,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AArCd;AAHA;EA0CgB,wCAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;AApChB;AATA;EAgDkB,2BAAA;EACA,eAAA;AApClB;AA+CA;EAMY,aAAA;AAlDZ;AA4CA;EAQc,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAjDd;AAoCA;EAoBkB,YAAA;AArDlB;AAiCA;EAsBoB,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AApDpB;AA2BA;EA6BkB,cAAA;EACA,kBAAA;AArDlB;AAuBA;EAiCkB,8BAAA;EACA,6BAAA;AArDlB;AAmBA;EAsCoB,cAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;AAtDpB;AAaA;EA6CsB,cAAA;AAvDtB;AAUA;EAgDsB,6HAAA;AAvDtB;AAOA;EAuDsB,uBAAA;AA3DtB;AAIA;EA6DgB,gBAAA;AA9DhB;AACA;EA+DkB,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA7DlB;AA4EA;EACE,wCAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;AA1EF;AA6EA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA3EF;AA8EA;EACE,eAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA5EF;AA+EA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA7EF;AAgFA;EACE,eAAA;AA9EF;AA6EA;EAGI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA7EJ;AAiFA;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA/EF;AAkFA;EACE,iBAAA;AAhFF;AAkFA;EACE,gBAAA;AAhFF;AAkFA;EACE,kBAAA;AAhFF;AAmFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAjFF;AAoFA;EACE,WAAA;AAlFF;AAoFA;EACE,UAAA;AAlFF;AAoFA;EACE,SAAA;AAlFF;AAqFA;EACE,2BAAA;EACA,8BAAA;AAnFF;AAqFA;EACE,2BAAA;EACA,8BAAA;AAnFF;AAqFA;EACE,2BAAA;EACA,8BAAA;AAnFF;AAqFA;EACE,2BAAA;EACA,8BAAA;AAnFF;AAqFA;EACE,2BAAA;EACA,8BAAA;AAnFF;AACA,qBAAqB;AAsFrB;EACE,SAAA;AApFF;AAsFA;EACE,eAAA;AApFF;AAsFA;EACE,cAAA;AApFF;AAsFA;EACE,YAAA;AApFF;AAsFA;EACE,cAAA;AApFF;AAsFA;EACE,YAAA;AApFF;AAsFA;EACE,YAAA;AApFF;AACA,yBAAyB;AAuFzB;EACE,wBAAA;AArFF;AAuFA;EACE,8BAAA;AArFF;AAuFA;EACE,6BAAA;AArFF;AAuFA;EACE,2BAAA;AArFF;AAuFA;EACE,6BAAA;AArFF;AAuFA;EACE,2BAAA;AArFF;AACA,4BAA4B;AAwF5B;EACE,2BAAA;AAtFF;AAwFA;EACE,iCAAA;AAtFF;AAwFA;EACE,gCAAA;AAtFF;AAwFA;EACE,8BAAA;AAtFF;AAwFA;EACE,gCAAA;AAtFF;AAwFA;EACE,8BAAA;AAtFF;AACA,0BAA0B;AAyF1B;EACE,cAAA;AAvFF;AAyFA;EACE,oBAAA;AAvFF;AAyFA;EACE,mBAAA;AAvFF;AAyFA;EACE,iBAAA;AAvFF;AAyFA;EACE,mBAAA;AAvFF;AAyFA;EACE,iBAAA;AAvFF;AACA,2BAA2B;AA0F3B;EACE,eAAA;AAxFF;AA0FA;EACE,qBAAA;AAxFF;AA0FA;EACE,oBAAA;AAxFF;AA0FA;EACE,kBAAA;AAxFF;AA0FA;EACE,oBAAA;AAxFF;AA0FA;EACE,kBAAA;AAxFF;AACA,8BAA8B;AA2F9B;EACE,aAAA;EACA,gBAAA;AAzFF;AA2FA;EACE,mBAAA;EACA,sBAAA;AAzFF;AA2FA;EACE,kBAAA;EACA,qBAAA;AAzFF;AA2FA;EACE,2BAAA;EACA,8BAAA;AAzFF;AA2FA;EACE,6BAAA;EACA,gCAAA;AAzFF;AA2FA;EACE,2BAAA;EACA,8BAAA;AAzFF;AA2FA;EACE,gBAAA;EACA,mBAAA;AAzFF;AACA,gCAAgC;AA4FhC;EACE,cAAA;EACA,eAAA;AA1FF;AA4FA;EACE,oBAAA;EACA,qBAAA;AA1FF;AA4FA;EACE,mBAAA;EACA,oBAAA;AA1FF;AA4FA;EACE,iBAAA;EACA,kBAAA;AA1FF;AA4FA;EACE,mBAAA;EACA,oBAAA;AA1FF;AA4FA;EACE,iBAAA;EACA,kBAAA;AA1FF;AA4FA;EACE,iBAAA;EACA,kBAAA;AA1FF;AACA,sBAAsB;AA8FtB;EACE,qBAAA;AA5FF;AA8FA;EACE,2BAAA;AA5FF;AA8FA;EACE,0BAAA;AA5FF;AA8FA;EACE,wBAAA;AA5FF;AA8FA;EACE,0BAAA;AA5FF;AA8FA;EACE,wBAAA;AA5FF;AACA,0BAA0B;AA+F1B;EACE,yBAAA;AA7FF;AA+FA;EACE,+BAAA;AA7FF;AA+FA;EACE,8BAAA;AA7FF;AA+FA;EACE,4BAAA;AA7FF;AA+FA;EACE,8BAAA;AA7FF;AA+FA;EACE,4BAAA;AA7FF;AACA,6BAA6B;AAgG7B;EACE,4BAAA;AA9FF;AAgGA;EACE,kCAAA;AA9FF;AAgGA;EACE,iCAAA;AA9FF;AAgGA;EACE,+BAAA;AA9FF;AAgGA;EACE,iCAAA;AA9FF;AAgGA;EACE,+BAAA;AA9FF;AAiGA;EACE,8BAAA;AA/FF;AAkGA;EACE,yBAAA;AAhGF;AAmGA;;EAGI,YAAA;AAlGJ;AAsGA;;EAGI,mBAAA;EACA,qBAAA;AArGJ;AAiGA;;;;EAYU,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;AAvGV;AAsFA;;;;EAoBY,gBAAA;EACA,eAAA;EACA,cAAA;AApGZ;AA8EA;;EA4BU,6BAAA;AAtGV;AA0EA;;EA+BU,8BAAA;AArGV;AAsEA;;EAuCU,4BAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAzGV;AA0GU;;EACE,6BAAA;AAvGZ;AAyGU;;EACE,2BAAA;AAtGZ;AA4GM;;EACE,cAAA;EACA,eAAA;AAzGR;AA+GA;EACE,WAAA;EACA,YAAA;AA7GF;AAgHA;EACE,mBAAA;EACA,kBAAA;AA9GF;AAiHA;EACE,mBAAA;AA/GF;AAkHA;EACE,mBAAA;AAhHF;AAmHA;;EAGI,oCAAA;EACA,cAAA;AAlHJ;AAsHA;;;;;;;;;;;;;;;;;EAiBE,kCAAA;EACA,gBAAA;AApHF;AAuHA;EAEI,wBAAA;AAtHJ;AAoHA;EAKI,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAtHJ;AA8GA;EAUM,aAAA;EACA,sBAAA;EACA,mBAAA;AArHN;AAwHI;EACE,cAAA;EACA,eAAA;AAtHN;AAqGA;EAoBM,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAtHN;AA2FA;EA8BM,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAtHN;AAkFA;EAwCI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;AAvHJ;AAyHI;EACE,yBAAA;EACA,oCAAA;EACA,0BAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,cAAA;EACA,WAAA;AAvHN;AA0HI;EACE,YAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;AAxHN;AAoDA;EAyEM,YAAA;AA1HN;AAiDA;EA8EI,cAAA;EACA,gCAAA;EACA,4BAAA;AA5HJ;AA4CA;EAmFI,wBAAA;AA5HJ;AAyCA;EAuFI,4BAAA;AA7HJ;AAiIA;EAEI,oCAAA;AAhIJ;AA8HA;EAIM,yBAAA;AA/HN;AAoIA;EAGM,sBAAA;EACA,4BAAA;EACA,6BAAA;AApIN;AA+HA;EAUI,WAAA;EACA,WAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAtIJ;AAmHA;EAuBI,iBAAA;AAvIJ;AAgHA;EAyBM,kBAAA;AAtIN;AA6GA;;EA+BI,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAxIJ;AAkGA;EA0CI,wBAAA;EACA,cAAA;EACA,YAAA;AAzIJ;AA6FA;EAgDI,eAAA;EACA,gBAAA;EACA,UAAA;AA1IJ;AAwFA;EAsDI,oCAAA;EACA,wBAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,gCAAA;EACA,2BAAA;EACA,2BAAA;AA3IJ;AA6EA;EAkEI,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;AA5IJ;AAqEA;EA0EI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AA5IJ;AA2DA;EAoFI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA5IJ;AAqDA;EAyFM,UAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,0BAAA;EACA,mCAAA;AA3IN;AA8KA;EACE;IACE,aAAA;IACA,sBAAA;EA5KF;AACF;AAyLA;EACE;;;;IAOU,iBAAA;IACA,gBAAA;IACA,eAAA;EA1LV;EAiLA;;;;IAWY,eAAA;EAtLZ;EA2KA;;IAoBU,4BAAA;IACA,gBAAA;EA3LV;EAsMA;IACE,aAAA;IACA,sBAAA;EApMF;EAuMA;IAIQ,eAAA;EAxMR;EAoMA;IAQM,eAAA;EAzMN;EAiMA;IAWM,eAAA;EAzMN;EA8LA;IAeI,2BAAA;EA1MJ;EA2LA;IAiBM,0BAAA;IACA,6BAAA;EAzMN;AACF;AAgNA;EACE;;;;IAOU,iBAAA;IACA,gBAAA;IACA,eAAA;EAjNV;EAwMA;;;;IAWY,eAAA;EA7MZ;EAkMA;;IAoBU,4BAAA;EAlNV;EAiOA;IACE,aAAA;IACA,sBAAA;EA/NF;EAkOA;IAIQ,eAAA;EAnOR;EA+NA;IAQM,eAAA;EApON;EA4NA;IAWM,eAAA;EApON;EAyNA;IAeI,2BAAA;EArOJ;EAsNA;IAiBM,0BAAA;IACA,6BAAA;EApON;AACF","sourcesContent":["@import url(\"../src/assets/Fonts/Poppins/stylesheet.css\");\n@import url(\"../src/assets/Styles/variables.less\");\n// @import \"~antd/dist/antd.less\";\n\n// GENERAL STYLES\n\n\n\n.logOutModal{\n .ant-modal-confirm {\n  .ant-modal-content {\n    .ant-modal-body {\n      .ant-modal-confirm-body-wrapper {\n        .ant-modal-confirm-body-has-title {\n          .ant-modal-confirm-paragraph {\n            .ant-modal-confirm-title{\n              color: @black-link;\n              font-weight: 700;\n            }\n            .ant-modal-confirm-content{\n              font-size: 14px;\n              color: @light-input;\n            }\n          }\n        }\n        .ant-modal-confirm-btns {\n          margin-top: 20px !important;\n          button {\n            &:nth-child(2) {\n              border: none !important;\n              background-color: transparent !important;\n              color: @light-input !important;\n            }\n          }\n        }\n      }\n    }\n  }\n }\n}\n\n\n\n.verifyEmailModal {\n  .ant-modal-confirm {\n    .ant-modal-content {\n      .ant-modal-body {\n        .ant-modal-confirm-body-wrapper {\n          .ant-modal-confirm-body-has-title {\n            .ant-modal-confirm-paragraph {\n              .ant-modal-confirm-title {\n                color: #040f0f;\n                text-align: center;\n                font-family: Poppins;\n                font-size: 24px;\n                font-style: normal;\n                font-weight: 700;\n              }\n              .ant-modal-confirm-content {\n                color: #a3a3a3;\n                text-align: center;\n                font-family: Poppins;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 400;\n              }\n            }\n          }\n          .ant-modal-confirm-btns {\n            button {\n              &:nth-child(2) {\n                border: none !important;\n                background-color: transparent !important;\n                color: @light-input !important;\n              }\n            }\n            p {\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              gap: 10px;\n              font-weight: 500 !important;\n              font-size: 14px;\n              margin-top: 10px;\n              .anchor-btn {\n                background-color: transparent !important;\n                border: none;\n                color: @primary-color !important;\n                padding: 0px !important;\n\n                span {\n                  font-weight: 600 !important;\n                  font-size: 14px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.formModal {\n  .ant-modal-confirm {\n    .ant-modal-body {\n      .ant-modal-confirm-body-wrapper {\n        .ant-modal-confirm-body {\n          .ant-modal-confirm-paragraph {\n            row-gap: 20px;\n            .ant-modal-confirm-title {\n              color: #040f0f;\n              font-family: Poppins;\n              font-size: 14px;\n              font-style: normal;\n              font-weight: 600;\n              text-align: left;\n            }\n          }\n          .ant-modal-confirm-content {\n            .custom-form-container {\n              .custom-form-item {\n                .customPhoneNumberWrapper {\n                  height: 100%;\n                  .PhoneInputInput {\n                    color: #000000e0;\n                    font-size: 15px;\n                    font-style: normal;\n                    font-weight: 300;\n                  }\n                }\n                .anticon {\n                  color: @light-input;\n                  padding-right: 4px;\n                }\n                button {\n                  border-radius: 12px !important;\n                  padding: 10px 35px !important;\n                }\n                .ant-form-item-control {\n                  .ant-form-item-explain-error {\n                    color: @highlight-color;\n                    font-weight: 300 !important;\n                    padding-left: 4px;\n                    padding-top: 10px;\n                  }\n                  .ant-input-status-error {\n                    svg {\n                      color: @primary-color;\n                    }\n                    img {\n                      filter: brightness(0) saturate(100%) invert(14%)\n                        sepia(84%) saturate(2948%) hue-rotate(339deg)\n                        brightness(110%) contrast(98%);\n                    }\n                  }\n                  .ant-input-password {\n                    input {\n                      padding: 0px !important;\n                    }\n                  }\n                }\n              }\n              .checkboxWrapper {\n                text-align: left;\n                span {\n                  color: #a3a3a3;\n                  font-size: 14px;\n                  font-style: normal;\n                  font-weight: 400;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n\n\n\n\n.iconButton {\n  background-color: transparent !important;\n  display: inline-block;\n  padding: 0 !important;\n  border: none !important;\n}\n\n.noConnectionLoader {\n  height: 100vh;\n  width: 100vw;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 11;\n  background: rgb(255 255 255 / 90%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\nh5 {\n  font-size: 13px;\n  font-weight: 500 !important;\n  line-height: 1;\n  letter-spacing: 0em;\n  margin: 0;\n  padding-bottom: 8px;\n}\n\np {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: 0em;\n  margin: 0;\n  padding-bottom: 8px;\n}\n\nul {\n  padding-left: 0;\n  li {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0em;\n    margin: 0;\n    padding-bottom: 5px;\n    list-style: none;\n  }\n}\n\n.ant-form-item-explain-error {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: @primary-font-family;\n  line-height: 1;\n  text-align: left;\n  padding-top: 4px;\n  padding-left: 12px;\n  letter-spacing: 0em;\n}\n\n.text-right {\n  text-align: right;\n}\n.text-left {\n  text-align: left;\n}\n.text-center {\n  text-align: center;\n}\n\n.aside {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.w-100 {\n  width: 100%;\n}\n.w-50 {\n  width: 50%;\n}\n.w-0 {\n  width: 0%;\n}\n\n.my-10 {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n.my-15 {\n  margin-top: 15px !important;\n  margin-bottom: 15px !important;\n}\n.my-20 {\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n}\n.my-25 {\n  margin-top: 25px !important;\n  margin-bottom: 25px !important;\n}\n.my-30 {\n  margin-top: 30px !important;\n  margin-bottom: 30px !important;\n}\n\n/* Margin Utilities */\n.m-0 {\n  margin: 0;\n}\n.m-1 {\n  margin: 0.25rem;\n}\n.m-2 {\n  margin: 0.5rem;\n}\n.m-3 {\n  margin: 1rem;\n}\n.m-4 {\n  margin: 1.5rem;\n}\n.m-5 {\n  margin: 3rem;\n}\n.m-auto {\n  margin: auto;\n}\n\n/* Margin Top Utilities */\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n.mt-3 {\n  margin-top: 1rem !important;\n}\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n/* Margin Bottom Utilities */\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n/* Margin Left Utilities */\n.ml-0 {\n  margin-left: 0;\n}\n.ml-1 {\n  margin-left: 0.25rem;\n}\n.ml-2 {\n  margin-left: 0.5rem;\n}\n.ml-3 {\n  margin-left: 1rem;\n}\n.ml-4 {\n  margin-left: 1.5rem;\n}\n.ml-5 {\n  margin-left: 3rem;\n}\n\n/* Margin Right Utilities */\n.mr-0 {\n  margin-right: 0;\n}\n.mr-1 {\n  margin-right: 0.25rem;\n}\n.mr-2 {\n  margin-right: 0.5rem;\n}\n.mr-3 {\n  margin-right: 1rem;\n}\n.mr-4 {\n  margin-right: 1.5rem;\n}\n.mr-5 {\n  margin-right: 3rem;\n}\n\n/* Vertical Margin Utilities */\n.my-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.my-1 {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n.my-auto {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n/* Horizontal Margin Utilities */\n.mx-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n.mx-1 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n.mx-2 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n.mx-3 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.mx-4 {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n.mx-5 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Padding Utilities */\n\n.p-0 {\n  padding: 0 !important;\n}\n.p-1 {\n  padding: 0.25rem !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n.p-3 {\n  padding: 1rem !important;\n}\n.p-4 {\n  padding: 1.5rem !important;\n}\n.p-5 {\n  padding: 3rem !important;\n}\n\n/* Padding Top Utilities */\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n.pt-3 {\n  padding-top: 1rem !important;\n}\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n/* Padding Bottom Utilities */\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.space-between {\n  justify-content: space-between;\n}\n\n.bordered {\n  border: 1px solid @chart-border-color;\n}\n\n#addEditContractForm,\n#addEditPlanForm {\n  .anticon-delete {\n    height: 45px;\n  }\n}\n\n.edit,\n.dashboardMain {\n  span.kl-custom-heading {\n    padding: 0 0 20px 0;\n    display: inline-block;\n  }\n\n  table {\n    .ant-table-thead > {\n      tr > {\n        th,\n        > td {\n          background-color: @table-header-color;\n          padding: 14px 10px;\n          color: @black-color;\n          font-weight: 500;\n          border: unset !important;\n          font-size: 15px;\n\n          span {\n            font-weight: 600;\n            font-size: 13px;\n            color: @black-color;\n          }\n        }\n      }\n      tr:first-child {\n        th:first-child {\n          padding-left: 20px !important;\n        }\n        th:last-child {\n          padding-right: 20px !important;\n        }\n      }\n    }\n\n    tbody {\n      > tr {\n        > td {\n          padding: 14px 8px !important;\n          border-right: none;\n          border-bottom: none !important;\n          color: @black-color;\n          font-size: 13px;\n          font-weight: 400;\n          line-height: 1.2;\n          letter-spacing: 0em;\n          &:first-child {\n            padding-left: 25px !important;\n          }\n          &:last-child {\n            padding-right: 0 !important;\n          }\n        }\n      }\n    }\n    .anticon {\n      &.anticon-delete {\n        color: @input-error-color;\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: @white-color;\n  border-radius: 0px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: @primary-color;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #3a3a3c;\n}\n\n.ant-picker-cell-hover,\n.ant-picker-cell-selected {\n  .ant-picker-cell-inner {\n    background-color: @primary-color !important;\n    color: @white-color;\n  }\n}\n\nhtml,\ndiv,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\na,\np,\nspan,\ntable,\nth,\ntd,\ninput,\ntextarea,\nselect {\n  font-family: @primary-font-family;\n  font-weight: 400;\n}\n\n.ant-modal-confirm {\n  .ant-modal-body {\n    padding: 35px !important;\n  }\n  .ant-modal-content {\n    background-color: @white-color;\n    min-height: auto;\n    border-radius: 8px;\n    padding: 0;\n    .ant-modal-confirm-body {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    & .icon-wrapper svg {\n      color: @primary-color;\n      font-size: 50px;\n    }\n    .ant-modal-confirm-title {\n      font-size: 23px;\n      font-weight: 500;\n      letter-spacing: 0em;\n      color: @primary-color;\n      text-align: center;\n      line-height: 1;\n      padding-top: 20px;\n      padding-bottom: 5px;\n    }\n    .ant-modal-confirm-content {\n      font-size: 20px;\n      font-weight: 400;\n      letter-spacing: 0em;\n      line-height: 20px;\n      letter-spacing: 0px;\n      text-align: center;\n      color: @black-color;\n    }\n  }\n  .ant-modal-confirm-btns {\n    border: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n    margin-top: 40px !important;\n\n    & .ant-btn {\n      color: @white-color !important;\n      background-color: @primary-color !important;\n      font-size: 16px !important;\n      font-family: \"Roboto\";\n      line-height: unset !important;\n      letter-spacing: 0em;\n      padding: 12px 40px !important;\n      font-weight: 500 !important;\n      box-shadow: none !important;\n      border-radius: 8px !important;\n      height: unset !important;\n      display: block;\n      width: 100%;\n    }\n\n    & .ant-btn:hover {\n      opacity: 0.8;\n      color: @primary-color !important;\n      background-color: #ffffff !important;\n      border-color: @primary-color !important;\n    }\n  }\n  .ant-modal-confirm-btns {\n    .ant-btn-primary:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .ant-modal-close {\n    color: #ad0c17;\n    transition: all 0.4s ease-in-out;\n    background: unset !important;\n  }\n  .ant-modal-close:hover {\n    transform: rotate(90deg);\n  }\n\n  .ant-modal-close:hover {\n    transform: translateX(20deg);\n  }\n}\n\n.delete-modal {\n  .icon-wrapper {\n    border-color: transparent !important;\n    svg {\n      color: #ad0c17 !important;\n    }\n  }\n}\n\n.form-modal {\n  .custom-row {\n    .ant-row {\n      flex-direction: column;\n      margin-left: 10px !important;\n      margin-right: 10px !important;\n    }\n  }\n\n  .ant-form-item-label > label {\n    color: #222;\n    width: 100%;\n    font-family: @primary-font-family;\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0px;\n    text-align: left;\n    line-height: 1;\n    height: unset;\n    margin-bottom: 10px;\n  }\n\n  .update-btn-row {\n    text-align: right;\n    button {\n      margin-right: 10px;\n    }\n  }\n\n  .kl-custom-input-container input,\n  .kl-custom-textarea-container textarea {\n    padding: 12px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 20px;\n    letter-spacing: 0px;\n    text-align: left;\n    color: #000;\n  }\n\n  .kl-custom-textarea-container textarea {\n    height: 260px !important;\n    overflow: auto;\n    resize: none;\n  }\n\n  .kl-custom-input-container input::placeholder {\n    font-size: 16px;\n    color: @placeholder;\n    opacity: 1;\n  }\n\n  .ant-btn {\n    border: 1px solid @primary-color !important;\n    height: unset !important;\n    padding: 8px 22px !important;\n    font-size: 14px !important;\n    border-radius: 4px !important;\n    color: @primary-color !important;\n    border-color: @primary-color !important;\n    background: #fff !important;\n    font-weight: 400 !important;\n  }\n\n  .imagePreview {\n    padding: 60px 0;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n  }\n  p {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    letter-spacing: 0px;\n    text-align: left;\n    color: #222;\n    margin-bottom: 0;\n    line-height: 1;\n  }\n  .aside {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    .forgot-pass button {\n      all: unset;\n      font-size: 14px !important;\n      font-weight: 500 !important;\n      letter-spacing: 0px;\n      text-align: right;\n      color: #636363 !important;\n      transition: all 0.4s ease-in-out;\n      background: unset !important;\n      border: none !important;\n      padding: 0 !important;\n      line-height: 1 !important;\n      text-shadow: unset !important;\n      box-shadow: unset !important;\n      border-radius: unset !important;\n      cursor: pointer !important;\n      border-bottom: 1px solid !important;\n    }\n  }\n}\n\n// .custom-column:last-child ::after{\n//   display: none;\n// }\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n  .filtersGrid {\n    display:flex;\n    flex-direction: column;\n  }\n  // .custom-column:last-child ::after{\n  //   display: none;\n  // }\n  // .custom-column:nth-child(2) ::after{\n  //   display: none;\n  // }\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .edit,\n  .dashboardMain {\n    table {\n      .ant-table-thead > {\n        tr > {\n          th,\n          > td {\n            padding: 10px 8px;\n            line-height: 1.2;\n            font-size: 13px;\n            span {\n              font-size: 13px;\n            }\n          }\n        }\n      }\n\n      tbody {\n        > tr {\n          > td {\n            padding: 10px 8px !important;\n            line-height: 1.2;\n          }\n        }\n      }\n    }\n  }\n\n  // .custom-column ::after{\n  //   display: none;\n  // }\n\n  .filtersGrid {\n    display:flex;\n    flex-direction: column;\n  }\n\n  .ant-modal-confirm {\n    .ant-modal-content {\n      .icon-wrapper {\n        svg {\n          font-size: 42px;\n        }\n      }\n      .ant-modal-confirm-title {\n        font-size: 22px;\n      }\n      .ant-modal-confirm-content {\n        font-size: 16px;\n      }\n    }\n    .ant-modal-confirm-btns {\n      margin-top: 20px !important;\n      .ant-btn {\n        font-size: 14px !important;\n        padding: 10px 20px !important;\n      }\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .edit,\n  .dashboardMain {\n    table {\n      .ant-table-thead > {\n        tr > {\n          th,\n          > td {\n            padding: 10px 8px;\n            line-height: 1.2;\n            font-size: 13px;\n            span {\n              font-size: 13px;\n            }\n          }\n        }\n      }\n\n      tbody {\n        > tr {\n          > td {\n            padding: 10px 8px !important;\n          }\n        }\n      }\n    }\n  }\n\n  // .custom-column ::after{\n  //   display: none;\n  // }\n\n  // .wrapper{\n  //   padding: 30px 10px;\n  // }\n\n  .filtersGrid {\n    display:flex;\n    flex-direction: column;\n  }\n\n  .ant-modal-confirm {\n    .ant-modal-content {\n      .icon-wrapper {\n        svg {\n          font-size: 42px;\n        }\n      }\n      .ant-modal-confirm-title {\n        font-size: 22px;\n      }\n      .ant-modal-confirm-content {\n        font-size: 16px;\n      }\n    }\n    .ant-modal-confirm-btns {\n      margin-top: 20px !important;\n      .ant-btn {\n        font-size: 14px !important;\n        padding: 10px 20px !important;\n      }\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
